import primitives from '@veneer/primitives';
import { semantics } from '@veneer/semantics';
var defaultTheme = {
  density: {
    standard: {
      borderRadius: addPx(primitives.layout.cornerRadius3),
      borderRadius1: addPx(primitives.layout.cornerRadius2),
      borderRadius2: addPx(primitives.layout.cornerRadius1),
      borderRadius3: addPx(primitives.layout.cornerRadius2),
      borderRadius4: addPx(primitives.layout.cornerRadius3),
      borderRadius5: addPx(primitives.layout.cornerRadius4),
      borderRadius6: addPx(primitives.layout.cornerRadius4),
      borderRadius7: addPx(primitives.layout.cornerRadius5),
      borderRadius8: addPx(primitives.layout.cornerRadius6),
      borderRadius9: addPx(primitives.layout.cornerRadius6),
      borderRadius10: addPx(primitives.layout.cornerRadius7),
      borderRadius11: addPx(primitives.layout.cornerRadius8),
      fontSizeThree: primitives.typography.size2,
      lineHeightThree: primitives.typography.lineHeight3,
      orbitalOne: addPx(primitives.layout.size1),
      orbitalTwo: addPx(primitives.layout.size2),
      orbitalThree: addPx(primitives.layout.size3),
      orbitalFour: addPx(primitives.layout.size4),
      orbitalFive: addPx(primitives.layout.size5),
      orbitalSix: addPx(primitives.layout.size6),
      orbitalSeven: addPx(primitives.layout.size7),
      orbitalEight: addPx(primitives.layout.size8),
      orbitalIntermediate: addPx(primitives.layout.size3),
      orbitalModalHorizontal: addPx(primitives.layout.size8 + primitives.layout.size4),
      orbitalModalVertical: addPx(primitives.layout.size8 + primitives.layout.size2),
      input: {
        trailingButtonPadding: addPx(primitives.layout.size2),
        textArea: {
          defaultTopPadding: addPx(primitives.layout.size5 + 2),
          defaultBottomPadding: addPx(primitives.layout.size2)
        }
      },
      passwordRequirements: {
        iconSize: addPx(primitives.layout.size6),
        itemMargin: addPx(primitives.layout.size1 - 2),
        bulletMargin: "".concat(addPx(primitives.layout.size2), "\n          ").concat(addPx(primitives.layout.size3), "\n          ").concat(addPx(primitives.layout.size2), "\n          ").concat(addPx(primitives.layout.size2)),
        iconPadding: 0,
        iconWidthHeight: addPx(primitives.layout.size6)
      },
      helperText: {
        iconErrorMarginTop: 0,
        textHelperMarginTop: addPx(primitives.layout.size1 - 2)
      }
    },
    high: {
      borderRadius: addPx(primitives.layout.cornerRadius2),
      borderRadius1: addPx(primitives.layout.cornerRadius1),
      borderRadius2: addPx(primitives.layout.cornerRadius1),
      borderRadius3: addPx(primitives.layout.cornerRadius2),
      borderRadius4: addPx(primitives.layout.cornerRadius3),
      borderRadius5: addPx(primitives.layout.cornerRadius3),
      borderRadius6: addPx(primitives.layout.cornerRadius4),
      borderRadius7: addPx(primitives.layout.cornerRadius4),
      borderRadius8: addPx(primitives.layout.cornerRadius5),
      borderRadius9: addPx(primitives.layout.cornerRadius6),
      borderRadius10: addPx(primitives.layout.cornerRadius6),
      borderRadius11: addPx(primitives.layout.cornerRadius7),
      fontSizeThree: primitives.typography.size1,
      lineHeightThree: primitives.typography.lineHeight2,
      orbitalOne: '0px',
      orbitalTwo: addPx(primitives.layout.size1),
      orbitalThree: addPx(primitives.layout.size2),
      orbitalFour: addPx(primitives.layout.size3),
      orbitalFive: addPx(primitives.layout.size4),
      orbitalSix: addPx(primitives.layout.size5),
      orbitalSeven: addPx(primitives.layout.size6),
      orbitalEight: addPx(primitives.layout.size7),
      orbitalModalHorizontal: addPx(primitives.layout.size8 + primitives.layout.size2),
      orbitalModalVertical: addPx(primitives.layout.size8),
      orbitalIntermediate: addPx(primitives.layout.size3 / 2),
      input: {
        trailingButtonPadding: addPx(primitives.layout.size2 / 4),
        textArea: {
          defaultTopPadding: addPx(primitives.layout.size3 + 2),
          defaultBottomPadding: addPx(primitives.layout.size1)
        }
      },
      passwordRequirements: {
        iconSize: addPx(primitives.layout.size5),
        itemMargin: 0,
        bulletMargin: "".concat(addPx(primitives.layout.size1 + 2), "\n          ").concat(addPx(primitives.layout.size2 + 2), "\n          ").concat(addPx(primitives.layout.size1 + 2), "\n          ").concat(addPx(primitives.layout.size1 + 2)),
        iconPadding: addPx(primitives.layout.size1 - 2),
        iconWidthHeight: addPx(primitives.layout.size5)
      },
      helperText: {
        iconErrorMarginTop: addPx(primitives.layout.size1 - 2),
        textHelperMarginTop: addPx(primitives.layout.size1 - 3)
      }
    }
  },
  shape: {
    sharp: {
      borderRadius: addPx(primitives.layout.cornerRadius0),
      borderRadius1: addPx(primitives.layout.cornerRadius0),
      borderRadius2: addPx(primitives.layout.cornerRadius0),
      borderRadius3: addPx(primitives.layout.cornerRadius0),
      borderRadius4: addPx(primitives.layout.cornerRadius0),
      borderRadius5: addPx(primitives.layout.cornerRadius0),
      borderRadius6: addPx(primitives.layout.cornerRadius0),
      borderRadius7: addPx(primitives.layout.cornerRadius0),
      borderRadius8: addPx(primitives.layout.cornerRadius0),
      borderRadius9: addPx(primitives.layout.cornerRadius0),
      borderRadius10: addPx(primitives.layout.cornerRadius0),
      borderRadius11: addPx(primitives.layout.cornerRadius0)
    }
  },
  elevation: {
    auto: 'auto',
    header: 1000,
    sideMenu: 1100,
    sideBar: 1200,
    modal: 1300,
    popover: 1400,
    tooltip: 1500,
    toast: 1600
  },
  layout: {
    size0: addPx(primitives.layout.size0),
    size1: addPx(primitives.layout.size1),
    size2: addPx(primitives.layout.size2),
    size3: addPx(primitives.layout.size3),
    size4: addPx(primitives.layout.size4),
    size5: addPx(primitives.layout.size5),
    size6: addPx(primitives.layout.size6),
    size7: addPx(primitives.layout.size7),
    size8: addPx(primitives.layout.size8),
    xsMax: addPx(semantics.breakpoint.xs.max),
    smMin: addPx(semantics.breakpoint.sm.min),
    smMax: addPx(semantics.breakpoint.sm.max),
    mdMin: addPx(semantics.breakpoint.md.min),
    mdMax: addPx(semantics.breakpoint.md.max),
    lgMin: addPx(semantics.breakpoint.lg.min),
    lgMax: addPx(semantics.breakpoint.lg.max),
    xlMin: addPx(semantics.breakpoint.xl.min)
  }
};
function addPx(numberValue) {
  return "".concat(numberValue ? numberValue : 0, "px");
}
export default defaultTheme;